import { CommonModule } from '@angular/common';
import { Component, ViewEncapsulation, Input } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { DefaultErrorMessages } from '../../../utils/error';
import { ControlValueAccesorDirective } from '../control-value/control-value.component';

@Component({
  standalone: true,
  selector: 'app-error-input',
  imports: [CommonModule, ControlValueAccesorDirective],
  templateUrl: './error-input.component.html',
  encapsulation: ViewEncapsulation.Emulated,
})
export class ErrorInputComponent {
  @Input() public controlName?: string;
  @Input() public formContained!: AbstractControl;
  @Input() public customErrorMessages: Record<string, string> = {};

  private get currentControl(): AbstractControl | null {
    if (this.formContained && this.controlName) {
      return this.formContained instanceof FormGroup
        ? this.formContained.get(this.controlName)
        : this.formContained;
    }
    return null;
  }

  protected get error(): string {
    const errorMessage = this.currentControl?.errors
      ? this.getErrorMessage(this.currentControl?.errors)
      : '';
    return errorMessage;
  }

  private getErrorMessage(errors: Record<string, any>): string {
    const [errorName] = Object.keys(errors);
    if (this.customErrorMessages[errorName]) {
      return this.customErrorMessages[errorName];
    }
    const errorFunction = DefaultErrorMessages[errorName];
    if (errorFunction) {
      return errorFunction(errors[errorName]);
    } else {
      return 'An error occurred';
    }
  }
}
